import Indicator from './component'
export { Indicator }
export default Indicator